// @ts-nocheck
import React, { useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEraser } from '@fortawesome/free-solid-svg-icons';
import { faArrowDownShortWide } from '@fortawesome/free-solid-svg-icons';
import SiteContext from '../Context/SiteContext';

export const NavBar = () => {
    const stateContext = useContext(SiteContext);
    return (
        <nav>
            <span className="logo"><a href="https://pmr745.github.io/PMR745/index.html" target='_blank'>PMR</a></span>
            <div className="extras">
                <div className="filterIcon" onClick={stateContext.handleFilter}>
                    <FontAwesomeIcon icon={faArrowDownShortWide} />
                </div>
                <div className="clear" onClick={stateContext.clearTransactions}>
                    <FontAwesomeIcon icon={faEraser} />
                </div>
            </div>
        </nav>
    )
}